import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const MODEL_FAMILY_UPDATE_RESOURCE = "model-family" as const;
export const MODEL_FAMILY_UPDATE_API_PATH = `/v1/${MODEL_FAMILY_UPDATE_RESOURCE}/{uuid}` as const;

export type ModelFamilyUpdateBody =
  paths[typeof MODEL_FAMILY_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type ModelFamilyUpdateInput = ModelFamilyUpdateBody & {
  uuid: string;
};
export type ModelFamilyUpdateResponse =
  paths[typeof MODEL_FAMILY_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useModelFamilyUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ModelFamilyUpdateResponse, Error, ModelFamilyUpdateInput>({
    mutationFn: async (data: ModelFamilyUpdateInput) => {
      const { uuid, ...rest } = data;
      const response = await alphartisApiAxios.patch<ModelFamilyUpdateResponse>(
        `/v1/${MODEL_FAMILY_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MODEL_FAMILY_UPDATE_RESOURCE],
      });
    },
  });
};
